import React from "react";
import { Spinner } from "react-redux-spinner";
import { styles } from "@common/styles";

export interface IFeedbackProps {
  message: string;
}

class Feedback extends React.Component<IFeedbackProps> {
  public render() {
    const { message } = this.props;
    if (!message) {
      return null;
    }

    const feedbackStyle = this.props.message
      ? { ...styles.feedbackTextContainer, color: "#7a1317" }
      : styles.feedbackTextContainer;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "30px 0px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "rgb(122, 19, 23)"
        }}
      >
        <Spinner config={{}} />
        <div style={feedbackStyle as any}>{message}</div>
      </div>
    );
  }
}

export default Feedback;
